<template>
    <div class="schedule-appointment" v-if="show">
      <hp5-call-to-action
        icon-name=""
        screen-reader-only-text="Schedule appointment"
        size="sm"
        type="secondary"
      >
        <a :data-card-rank="rank" href="/care/appointments/" target="_self">Schedule appointment</a>
      </hp5-call-to-action>
      <hp5-spacing-vertical xs="xxs"></hp5-spacing-vertical>
    </div>
</template>

<script setup>

  const props = defineProps({
    location: Object,
    rank: Number
  })

  const show = computed(() => props.location.onlineAppointmentAvailable)

</script>
  
<style lang="scss" scoped>
  .schedule-appointment {
    margin-right: var(--spacing-sm);
  }
</style>